<div
  *ngIf="isVisible"
  class="onboarding-bar flex items-center gap-3 bg-accent/20 border-b border-accent px-4 py-2 text-sm text-primary"
>
  <!--
    The whole left side is one button (not just "Continue") so it's a big, easy tap target on
    phones, with a hover/focus background so it's visible that more than "Continue" is clickable.
    No progress count - only two steps are required (the wishlist and a first name).
    "Remind me later" stays a separate button so it can't be hit by accident.
  -->
  <button
    type="button"
    class="flex flex-1 min-w-0 items-center gap-3 text-left -mx-2 px-2 py-1 rounded hover:bg-accent/60 focus-visible:bg-accent/60 focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary"
    (click)="open()"
    aria-label="Continue setting up your account"
  >
    <mat-icon class="!text-lg !w-auto !h-auto shrink-0">checklist</mat-icon>
    <span class="font-medium truncate">Finish setting up</span>
    <span class="ml-auto font-medium underline whitespace-nowrap">Continue</span>
  </button>

  <button
    type="button"
    class="shrink-0 font-medium underline whitespace-nowrap"
    (click)="snooze()"
    aria-label="Remind me later"
  >
    <span class="sm:hidden">Later</span>
    <span class="hidden sm:inline">Remind me later</span>
  </button>
</div>
